import React from 'react';
import { Link } from 'react-router-dom';
import { colors, fontFamily, fontSizes, fontWeights, layout } from '../../theme/tokens';
import { SITE } from '../../config/siteContent';
import { POLICIES } from '../../config/policies';
import { LOGO_IMAGES } from '../../config/imagePaths';
import { useIsMobile } from '../../hooks/useMediaQuery';

const SITE_DOMAIN = 'vidyarthibookbank.com';
const SITE_URL = 'https://' + SITE_DOMAIN;

const SiteFooter = () => {
  const isMobile = useIsMobile();
  const gutter = isMobile ? layout.gutterMobile : layout.gutter;

  const linkStyle = {
    fontSize: fontSizes.body - 1, color: colors.footerText, textDecoration: 'none', fontFamily,
    background: 'none', border: 0, padding: 0, textAlign: 'left', cursor: 'pointer', overflowWrap: 'anywhere',
    minHeight: isMobile ? 32 : undefined, display: 'inline-flex', alignItems: 'center',
  };
  const heading = { margin: '0 0 4px', fontSize: fontSizes.h3, fontWeight: fontWeights.semibold, color: colors.white };
  const col = { display: 'flex', flexDirection: 'column', gap: 12, minWidth: 0, alignItems: 'flex-start' };

  return (
    <footer style={{ width: '100%', background: colors.navyNight, color: colors.white, fontFamily }}>
      <div
        style={{
          maxWidth: layout.containerMax, margin: '0 auto', padding: (isMobile ? '40px ' : '56px ') + gutter + 'px 32px',
          boxSizing: 'border-box', display: 'grid', gap: isMobile ? 32 : 48,
          gridTemplateColumns: isMobile ? 'minmax(0, 1fr)' : 'repeat(3, minmax(0, 1fr))',
        }}
      >
        <div style={col}>
          <h3 style={heading}>About Us</h3>
          <p style={{ margin: 0, fontSize: fontSizes.body - 1, lineHeight: 1.7, color: colors.footerText }}>{SITE.aboutText}</p>
          <a href={SITE_URL} target="_blank" rel="noopener noreferrer" style={linkStyle}>{SITE_DOMAIN}</a>
        </div>
        <nav aria-label="Footer" style={col}>
          <h3 style={heading}>Menu</h3>
          <Link to="/search" style={linkStyle}>School Zone</Link>
          {POLICIES.map((p) => (
            <Link key={p.slug} to={p.path} style={linkStyle}>{p.title}</Link>
          ))}
        </nav>
        <div style={col}>
          <h3 style={heading}>Contact Us</h3>
          {SITE.supportPhone && <a href={'tel:' + SITE.supportPhone.replace(/[^\d+]/g, '')} style={linkStyle}>{SITE.supportPhone}</a>}
          {SITE.supportEmail && <a href={'mailto:' + SITE.supportEmail} style={linkStyle}>{SITE.supportEmail}</a>}
          <Link to="/" aria-label="Vidyarthi Book Bank home" style={{ marginTop: 8, display: 'inline-block', background: colors.white, borderRadius: 12, padding: 6 }}>
            <img
              src={LOGO_IMAGES.BOOK_BANK}
              alt="Vidyarthi Book Bank"
              style={{ height: isMobile ? 104 : 120, width: 'auto', objectFit: 'contain', display: 'block' }}
            />
          </Link>
          <a href={SITE_URL} target="_blank" rel="noopener noreferrer" style={linkStyle}>{SITE_DOMAIN}</a>
        </div>
      </div>
      <div
        style={{
          maxWidth: layout.containerMax, margin: '0 auto', padding: '20px ' + gutter + 'px 28px', boxSizing: 'border-box',
          borderTop: '1px solid ' + colors.navyLine, fontSize: fontSizes.small, color: colors.footerMuted,
        }}
      >
        {'©'} {new Date().getFullYear()} VidyarthiKart. All Rights Reserved.
      </div>
    </footer>
  );
};

export default SiteFooter;
